import { trackEvent } from 'dibs-tracking';

type Args = {
    isFollowing: boolean;
    label: string;
};

const trackFollowButtonClick = ({ isFollowing, label }: Args): void => {
    const action = isFollowing ? 'added' : 'removed';

    trackEvent({
        category: 'search favoriting',
        action: `search ${action}`,
        label,
        value: 0,
    });
};

export { trackFollowButtonClick };
